<!--安装订单详细页-->
<template>
    <div>
        <van-sticky>
            <div style="padding: 10px 0px 0px 0px">
                <van-icon name="arrow-left" size="20px" @click="onback"/>
            </div>
        </van-sticky>
        <div class="content">
            <Card style="width:100%">
                <cell size="small" style="padding: 0px;">
                    <label>订单号：
                        <label style="color: #0077aa;">{{installlist.orderNum}}</label>
                    </label><br/>
                </cell>

                <div class="mid">
                                <span class="count fl">车牌号:
                                    <label style="color: #0077aa;">{{installlist.vehicleInfo===null?installlist.tempVehicleInfo.registrationNum:installlist.vehicleInfo.registrationNum}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                    <span class="distance fr">|</span>
                    <span class="time fr">车架号:
                                    <label style="color: #0077aa;">{{installlist.vehicleInfo==null?installlist.tempVehicleInfo.vin:installlist.vehicleInfo.vin}}</label>
                                </span>
                </div>
                <div class="mid">
                                <span class="count fl">发动机号:
                                    <label style="color: #0077aa;">{{installlist.vehicleInfo==null?installlist.tempVehicleInfo.engineNum:installlist.vehicleInfo.engineNum}}</label>
                                </span>
                </div>

                <div class="mid">
                    <span class="count fl">订单金额:
                        <label style="color: #0077aa;">{{installlist.totalAmount}}</label>
                    </span>
                </div>

                <div class="mid">
                    <span class="count fl">客户姓名:<label style="color: #0077aa;">{{installlist.vehicleInfo!=null?installlist.vehicleInfo.clientInfo!=null?installlist.vehicleInfo.clientInfo.name:installlist.clientInfo!=null?installlist.clientInfo.name:'无':'无'}}</label></span>
                    <span class="distance fr">|</span>
                    <span class="count fl">客户电话:<label style="color: #0077aa;">{{installlist.vehicleInfo!=null?installlist.vehicleInfo.clientInfo!=null?installlist.vehicleInfo.clientInfo.phoneNum:installlist.clientInfo!=null?installlist.clientInfo.phoneNum:'无':'无'}}</label></span>
                </div>

                <div class="mid">
                    <span class="count fl">车辆所有人名称:<label
                            style="color: #0077aa;">{{vehicleOwnerInfo.name}}</label></span>
                </div>

                <div class="mid">
                    <span class="count fl">车辆品牌:<label style="color: #0077aa;">{{vehiclebrand}}</label></span>
                    <span class="distance fr">&nbsp;|&nbsp;</span>
                    <span class="count fl">车辆类型:<label style="color: #0077aa;">{{vehicletype}}</label></span>
                </div>

                <div class="mid">
                    <span class="count fl">服务到期时间:<label style="color: #0077aa;">{{new Date(installlist.serviceDatetime).Format('yyyy年MM月dd日')}}</label></span>
                </div>

                <div class="mid">
                    <span class="count fl">安装状态:<label
                            style="color: #0077aa;">{{installlist.installed===true?'已安装':'未安装'}}</label></span>
                    <span class="distance fr">&nbsp;|&nbsp;</span>
                    <span class="time fr">安装员:<label style="color: #0077aa;">{{installlist.installer===null?'未指派':installlist.installer.realName}}</label></span>
                </div>


                <div class="mid">
     <span class="count fl">订单状态:<label
             :class="[installlist.state===1?'s1':installlist.state===2?'s2':installlist.state===0?'s3':'s4']">
       {{installlist.state===1?'正在处理':installlist.state===2?'完成':installlist.state===0?'作废':'异常'}} </label></span>
                    <span class="distance fr">|</span>
                    <span class="time fr"> 配机:<label style="color: #0077aa;">{{installlist.positioningDeviceInfosCount===0?'未分配':'已分配'}}</label></span>
                </div>

                <div class="mid">
                    <span class="count fl">业务跟进员:
                        <label style="color: #0077aa;">{{installlist.businessUser.realName}}</label>
                    </span>
                    <span class="distance fr">|</span>
                    <span class="count fl">销售渠道:
                                            <label style="color: #0077aa;">{{installlist.salesChannel==null?null:installlist.salesChannel.name}}</label>
                                        </span>
                </div>

                <div class="mid">
                    <span class="count fl">上传状态:<label style="color: #0077aa;">{{installlist.uploadState===1?'资料不完整':installlist.uploadState===2?'待上传':'已上传'}}</label></span>
                    <span class="distance fr">|</span>
                    <span class="time fr"> 开票类型:<label style="color: #0077aa;">{{installlist.billType===1?'增值税发票':installlist.billType===2?'增值税专用发票':'增值税普通发票'}}</label></span>
                </div>

                <div class="mid">
                    <label>缺少资料：
                        <label style="color: red">{{installlist.qghyptOption===
                            0?text1(installlist):installlist.qghyptOption===
                            1?text2(installlist):text3(installlist)}}</label></label>&nbsp;<br>
                    <div v-if="installlist.state===2||installlist.state===0?false:true">
                        <van-button size="small" type="info" @click="toUploaderimage(installlist)">上传图片
                        </van-button>&nbsp;&nbsp;
                        <van-button size="small" type="info" :disabled="discern"
                                    @click="onAnalyzeVehicleLicensePicture(installlist.id)">识别行驶证
                        </van-button>
                    </div>
                </div>

                <div class="mid">
                    <van-button size="small" type="info" @click="onBindPositioningDevicesModal(installlist)">配机
                    </van-button>&nbsp;&nbsp;
                    <van-button size="small" type="info" @click="onBindPositioningDevicesFittingsModal(installlist)">配件
                    </van-button>
                </div>

                <div class="mid">
                    <van-button size="small" type="info" @click="modifyRemark(installlist)">修改备注
                    </van-button>
                    <br>
                    <label>备注:{{installlist.remark}}</label><br>
                    <br>
                    <label>追加备注:
                        <div v-if="installlist.installRemark!=null">
                            <label v-for="item2 in installlist.installRemark.split('\r\n')">{{item2}}<br></label>
                        </div>
                    </label>
                </div>

                <div class="mid">
                    <label>订单记录:
                        <label v-for="item2 in installlist.history.split('\r\n')">{{item2}}<br></label>
                    </label>
                </div>


            </Card>
            <div style="height: 3px"></div>
            <!--                        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">-->
            <!--                        </van-divider>-->
        </div>
        <div>
            <Modal
                    v-model="modal1"
                    title="添加备注"
                    @on-ok="ok"
                    @on-cancel="cancel">
                <van-cell-group>
                    <van-field
                            v-model="modifyremark"
                            rows="2"
                            autosize
                            type="textarea"
                            maxlength="250"
                            placeholder="请输入备注信息"
                            show-word-limit
                    />
                </van-cell-group>
            </Modal>
        </div>
        <bind-positioning-devices-modal v-model="bindPositioningDevicesModal" :initValue="bindPositioningDevicesId"
                                        @on-success="onModifySuccess"></bind-positioning-devices-modal>
        <bind-positioning-devices-fittings-modal v-model="bindPositioningDevicesFittingsModal" :initValue="bindPositioningDevicesFittingsId"
                                                 @on-success="onModifySuccess"></bind-positioning-devices-fittings-modal>
    </div>
</template>

<script>
    import Vue from 'vue'
    import store from '@/store'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
    import BindPositioningDevicesModal from '@/views/im/components/bind-positioning-devices-modal'
    import BindPositioningDevicesFittingsModal from '@/views/im/components/bind-positioning-devices-fittings-modal'

    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
    } from 'vant'


    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast);

    export default {
        name: "orderDetails",
        components: {
            BindPositioningDevicesModal,
            BindPositioningDevicesFittingsModal,
        },
        data() {
            return {
                //返回路径
                onbackid:null,

                // 安装订单配置设备
                bindPositioningDevicesModal: false,
                bindPositioningDevicesId: null,

                // 安装订单配置定位设备配件
                bindPositioningDevicesFittingsModal: false,
                bindPositioningDevicesFittingsId: null,

                installlist: [],
                discern: false,
                modifyremark: '',
                modal1: false,
                clientInfoId: '',
                clientInfo: '',
                vehicleOwnerInfoid: '',
                vehicleOwnerInfo: '',

                vehiclebrand: '',
                vehicletype: '',
            }
        },
        methods: {
            //返回上一页
            onback() {
                this.$router.push({
                    path: this.onbackid,
                })
            },
            //上传图片路径
            toUploaderimage(e) {
                console.log(e)
                this.$root.installid = e
                this.$router.push({
                    path: '/Uploaderimage',
                    query: {'item': e.id}
                })
            },
            //识别行车证
            onAnalyzeVehicleLicensePicture(e) {
                this.discern = true
                //车辆信息
                store.dispatch('InstallOrderServ_GetDetail', {
                    params: {id: e},
                    urlparams: null
                }).then((res) => {


                    if (res.data.vehicleInfoId) {
                        //已完成的订单
                        //  识别行驶证
                        store.dispatch('VehicleInfoServ_AnalyzeVehicleLicensePicture', {
                            params: {id: res.data.vehicleInfoId},
                            urlparams: null
                        }).then((res) => {
                            console.log(res)
                            this.discern = false
                            this.onFind()
                        }).catch((err) => {
                            Toast(err)
                            this.discern = false
                        })
                    } else {
                        //未完成的订单

                        let installOrder = store.getters.get_InstallOrder_GetDetailResult
                        this.installOrder = installOrder
                        let vehicleInfo = this.installOrder.tempVehicleInfo
                        if (vehicleInfo.vehicleLicensePicture) {
                            //  识别行驶证
                            store.dispatch('InstallOrderServ_AnalyzeVehicleLicensePicture', {
                                params: {id: e},
                                urlparams: null
                            }).then((res) => {
                                console.log(res)
                                this.discern = false
                                this.onFind()
                            }).catch((err) => {
                                Toast(err + '请重新上传');
                                // this.$Message.error(err + '请重新上传');
                                this.discern = false
                            })
                        } else {
                            Toast('未上传行驶证');
                            // this.$Message.warning('未上传行驶证');
                            this.discern = false
                        }
                    }
                }).catch((err) => {
                    console.log(err)
                    this.discern = false
                })
            },
            // <!-- 搜索方法，默认state不为0，排除作废订单 -->
            onFind() {
                let id
                if (this.$route.query.code != null) {
                    this.getCode()
                    id = this.$route.query.installid
                } else {
                    id = this.$route.params.installid
                }
                store.dispatch('InstallOrderServ_GetDetail', {
                    params: {
                        id: id
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    this.installlist = res.data
                }).catch((err) => {
                    console.log(err)

                })
            },

            //修改备注
            modifyRemark() {
                this.modal1 = true
            },
            ok() {
                console.log(this.installlist)
                store.dispatch('InstallOrderServ_ModifyInstallOrderBase', {
                    params: {
                        id: this.installlist.id,
                        totalAmount: this.installlist.totalAmount,//应收总金额
                        serviceDatetime: this.installlist.serviceDatetime,//服务到期时间
                        // businessUserId: this.installlist.businessUserId,//跟进业务员id
                        businessType: this.installlist.businessType,//业务类型
                        qghyptOption: this.installlist.qghyptOption,//上传货运平台选项
                        remark: this.modifyremark,//备注
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    this.onFind()
                }).catch((err) => {
                    console.log(err)
                })
            },
            //添加备注取消
            cancel() {
            },

            //缺少资料文字转换
            text1(item) {
                let text = ''
                if (item.tempVehicleInfo!=null) {
                    if (!item.tempVehicleInfo.vehicleLicensePictureId) {
                        text = ' 行驶证'
                    }
                    if (!item.tempVehicleInfo.vehicleLicenseFlapPictureId) {
                        text = text + ' 行驶证副页'
                    }
                }
                return text
            },
            text2(item) {
                let text = ''
                if (item.tempVehicleInfo!=null) {
                    if (!item.tempVehicleInfo.vehicleLicensePictureId) {
                        text = ' 行驶证'
                    }
                    if (!item.tempVehicleInfo.vehicleLicenseFlapPictureId) {
                        text = text + ' 行驶证副页'
                    }
                    if (!item.tempVehicleInfo.vehicleSrcLicensePicture1Id) {
                        text = text + ' 登记证1'
                    }
                }
                return text
            },
            text3(item) {
                let text = ''
                if (item.tempVehicleInfo!=null) {
                    if (!item.tempVehicleInfo.vehicleLicensePictureId) {
                        text = ' 行驶证'
                    }
                    if (!item.tempVehicleInfo.vehicleLicenseFlapPictureId) {
                        text = text + ' 行驶证副页'
                    }
                    if (!item.tempVehicleInfo.vehicleSrcLicensePicture1Id) {
                        text = text + ' 登记证1'
                    }
                    if (!item.tempVehicleInfo.idFilePictureId) {
                        text = text + ' 身份识别文件'
                    }
                    if (!item.tempVehicleInfo.qghyptChangeContractPictureId) {
                        text = text + ' 转网合同'
                    }
                    if (!item.tempVehicleInfo.qghyptChangeAuthorizationPictureId) {
                        text = text + ' 授权书'
                    }
                }
                return text
            },


            getCode() { // 非静默授权，第一次有弹框
                let code = this.$route.query.code
                if (!code) {
                    code = null
                }
                // window.location.href = 'https://devwxpa.jianchengjt.com/?code=' + code
                // 你自己的业务逻辑
                //微信公众服务号登录
                store.dispatch('AccountServ_LoginByWechatServiceAccount', {
                    params: {
                        wechatCode: code
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    console.log('登陆成功')
                    // this.$router.push({
                    //     name: 'orderDetails',
                    // })
                })
                    .catch((err) => {
                        console.log(err)
                        console.log('登陆失败')
                        // this.$router.push({
                        //     name: 'login',
                        // })
                    })
            },
//配机
            onBindPositioningDevicesModal(e){
                this.bindPositioningDevicesModal = true
                this.bindPositioningDevicesId = e.id
            },
            onBindPositioningDevicesFittingsModal(e){
                this.bindPositioningDevicesFittingsId = e.id
                this.bindPositioningDevicesFittingsModal = true
            },
        },
        mounted() {
            // console.log(this.$route.params)
            // console.log(this.$route.params.installid)
            console.log(this.$route.query)
            this.onbackid = this.$route.query.install
            let id
            if (this.$route.query.code != null) {
                this.getCode()
                id = this.$route.query.installid
            } else {
                id = this.$route.query.installid
            }
            store.dispatch('InstallOrderServ_GetPage', {
                params: null,
                urlparams: {q:genQueryParam('id', 'EQ', id)}
            }).then((res) => {
                console.log(res)
                this.installlist = res.data.content[0]
                console.log(this.installlist)
                if (this.installlist.remark == null) {
                    this.modifyremark = ''
                } else {
                    this.modifyremark = this.installlist.remark
                }
                if (this.installlist.clientInfoId) {
                    this.clientInfoId = this.installlist.clientInfoId
                }
                if (this.installlist.vehicleInfo != null) {
                    this.vehicleOwnerInfoid = this.installlist.vehicleInfo
                } else {
                    this.vehicleOwnerInfoid = this.installlist.tempVehicleInfo
                }

                //客户信息
                store.dispatch('ClientInfoServ_GetDetail', {
                    params: {
                        id: this.clientInfoId
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    this.clientInfo = res.data
                }).catch((err) => {
                    console.log(err)
                })
                //车辆所有人信息
                let vehicleOwnerInfoId = this.vehicleOwnerInfoid.vehicleOwnerInfoId
                store.dispatch('VehicleOwnerInfoServ_GetDetail', {
                    params: {
                        id: vehicleOwnerInfoId
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    this.vehicleOwnerInfo = res.data
                }).catch((err) => {
                    console.log(err)
                })
                //获取车辆品牌详细信息 VehicleBrandServ_GetDetail
                if (this.vehicleOwnerInfoid.vehicleBrandId != null) {
                    let vehicleBrandId = this.vehicleOwnerInfoid.vehicleBrandId
                    store.dispatch('VehicleBrandServ_GetDetail', {
                        params: {
                            id: vehicleBrandId
                        },
                        urlparams: null
                    }).then((res) => {
                        console.log(res)
                        this.vehiclebrand = res.data.name
                    }).catch((err) => {
                        console.log(err)
                    })
                }
                //获取车辆型号详细信息 VehicleTypeServ_GetDetail
                if (this.vehicleOwnerInfoid.vehicleTypeId != null) {
                    let vehicleTypeId = this.vehicleOwnerInfoid.vehicleTypeId
                    store.dispatch('VehicleTypeServ_GetDetail', {
                        params: {
                            id: vehicleTypeId
                        },
                        urlparams: null
                    }).then((res) => {
                        console.log(res)
                        this.vehicletype = res.data.name
                    }).catch((err) => {
                        console.log(err)
                    })
                }

            }).catch((err) => {
                console.log(err)
            })
        },

    }
</script>

<style scoped>
    .s1 {
        color: blue;
    }

    .s2 {
        color: yellowgreen;
    }

    .s3 {
        color: blueviolet;
    }

    .s4 {
        color: red;
    }

    /*月售、送达时间、距离*/
    .content .mid {
        flex: 1;
        margin-top: 7px;
        color: #666;
        font-size: 12px;
    }
</style>
